// extracted by mini-css-extract-plugin
export default {"label":"egQbskcNJFl6Q6iokfk8","h3":"vHkTk6Ntue4JXTyVUCKR","h5":"VxVeH610kdwpOmR4JsSw","controlLabel":"tBEfgv0XXWThGwJxz8zL","startOverButton":"VaL_LZCK35Affnbur2gd"};